// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/download-asset-request-schema',
  type: 'object',
  required: ['orderId', 'orderItemId', 'assetId'],
  properties: {
    orderId: {
      type: 'integer',
    },
    orderItemId: {
      type: 'integer',
    },
    assetId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
